import {Store} from '@/lib/store';
import { observable, action, reaction } from 'mobx';
// import { tokenParam } from '../interface';
import { getDocList,getActorList } from './admin';

export default class AdminStore{

    Store: Store;
    constructor(Store: Store) {
        this.Store = Store;
    }

    @action getDocList = async (param:any) => {
        try 
        {   
            const list = await getDocList(param);
            return list;
        } catch (error) {
            throw error;
        }
    }

    @action getActorList = async (param:any) => {
        try 
        {   
            const list = await getActorList(param);
            return list.result;
        } catch (error) {
            throw error;
        }
    }

    
}
